module.exports = __webpack_public_path__ + "assets/images/Radiation_warning_symbol2.svg";